import React, { useEffect } from 'react';
import './home.css';
import './support.css';
import FadeInSection from '../animation/fadein_onscroll';
import { useTranslation } from 'react-i18next';


function Support() {
  const { t } = useTranslation();

  useEffect(() => {
    const anchors = document.querySelectorAll('a[data-scroll]');

    const handleAnchorClick = (e) => {
      e.preventDefault();
      const target = document.querySelector(e.currentTarget.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    };
  
    anchors.forEach(anchor => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    return () => {
      anchors.forEach(anchor => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []);

  useEffect(() => {
    // Load HubSpot form script
    const script = document.createElement('script');
    script.src = 'https://js-eu1.hsforms.net/forms/embed/145511650.js';
    script.defer = true;
    script.type = 'text/javascript';

    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="support-page-padding" id="start">
      <FadeInSection>
        <h1 className="support-page-title">{t('support.title')}</h1>
      </FadeInSection>
      <div className="max-width">
        <FadeInSection>
          <p className="support-page-description">
            {t('support.description')}
          </p>
        </FadeInSection>
      </div>
      <div className="hubspotForm" style={{ marginTop: '2rem' }}>
        <div 
          className="hs-form-frame" 
          data-region="eu1" 
          data-form-id="b504c3b4-1876-43ea-9dc6-4f9e054ba29e" 
          data-portal-id="145511650"
        ></div>
      </div>
    </div>
  );
}

export default Support;

